import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import UsermanMenu from "../components/UsermanMenu";

const UsermanProfileLimitation = () => {
  const [searchParams] = useSearchParams();
  const usermanId = searchParams.get("userman_id");
  const deviceName = searchParams.get("device_name");

  const [limitations, setLimitations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [filterName, setFilterName] = useState("");

  const [formData, setFormData] = useState({
    profile: "",
    limitation: "",
    from_time: "",
    till_time: "",
    weekdays: "",
  });

  const showToast = (message, type) => {
    setToastMessage(message);
    setToastType(type);
    setTimeout(() => setToastMessage(""), 3000);
  };

  const fetchLimitations = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://api.wifikamu.my.id/userman-profile-limitation-get/1"
      );
      if (!response.ok) throw new Error("Gagal mengambil data dari API.");
      const result = await response.json();
      if (result.success) {
        setLimitations(result.data);
        showToast("Data limitasi berhasil dimuat.", "success");
      } else {
        throw new Error(result.message || "Gagal mengambil data limitasi.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast(`Error: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLimitations();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        "https://api.wifikamu.my.id/userman-profile-limitation-add",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userman_id: 1,
            newUserProfile: {
              profile: formData.profile,
              limitation: formData.limitation,
              from_time: formData.from_time,
              till_time: formData.till_time,
              weekdays: formData.weekdays,
            },
          }),
        }
      );
      if (!response.ok) throw new Error("Gagal menambahkan data.");
      const result = await response.json();
      if (result.success) {
        showToast("Data berhasil ditambahkan.", "success");
        fetchLimitations();
        setIsAddModalOpen(false);
      } else {
        throw new Error(result.message || "Gagal menambahkan data.");
      }
    } catch (error) {
      console.error("Error adding data:", error);
      showToast(`Error: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(
        "https://api.wifikamu.my.id/userman-profile-limitation-update",
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userman_id: 1,
            mikrotik_id: itemToEdit[".id"],
            updatedUserProfile: {
              profile: formData.profile,
              limitation: formData.limitation,
              from_time: formData.from_time,
              till_time: formData.till_time,
              weekdays: formData.weekdays,
            },
          }),
        }
      );
      if (!response.ok) throw new Error("Gagal memperbarui data.");
      const result = await response.json();
      if (result.success) {
        showToast("Data berhasil diperbarui.", "success");
        fetchLimitations();
        setIsEditModalOpen(false);
      } else {
        throw new Error(result.message || "Gagal memperbarui data.");
      }
    } catch (error) {
      console.error("Error updating data:", error);
      showToast(`Error: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteConfirm = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://api.wifikamu.my.id/userman-profile-limitation-delete",
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userman_id: 1,
            mikrotik_id: itemToDelete[".id"],
          }),
        }
      );
      if (!response.ok) throw new Error("Gagal menghapus data.");
      const result = await response.json();
      if (result.success) {
        showToast("Data berhasil dihapus.", "success");
        fetchLimitations();
        setIsDeleteModalOpen(false);
      } else {
        throw new Error(result.message || "Gagal menghapus data.");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      showToast(`Error: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (item) => {
    setItemToEdit(item);
    setFormData({
      profile: item.profile,
      limitation: item.limitation,
      from_time: item["from-time"],
      till_time: item["till-time"],
      weekdays: item.weekdays,
    });
    setIsEditModalOpen(true);
  };

  const openDeleteModal = (item) => {
    setItemToDelete(item);
    setIsDeleteModalOpen(true);
  };

  const filteredLimitations = limitations.filter((item) =>
    item.profile.toLowerCase().includes(filterName.toLowerCase())
  );

  const renderForm = (isEdit = false) => (
    <form
      onSubmit={isEdit ? handleEditSubmit : handleAddSubmit}
      className="space-y-4"
    >
      <input
        type="text"
        name="profile"
        value={formData.profile}
        onChange={handleInputChange}
        placeholder="Nama Profil"
        className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        required
      />
      <input
        type="text"
        name="limitation"
        value={formData.limitation}
        onChange={handleInputChange}
        placeholder="Nama Limitasi"
        className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        required
      />
      <div className="grid grid-cols-2 gap-4">
        <input
          type="text"
          name="from_time"
          value={formData.from_time}
          onChange={handleInputChange}
          placeholder="Waktu Mulai (contoh: 08h00m00s)"
          className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          required
        />
        <input
          type="text"
          name="till_time"
          value={formData.till_time}
          onChange={handleInputChange}
          placeholder="Waktu Selesai (contoh: 17h00m00s)"
          className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          required
        />
      </div>
      <input
        type="text"
        name="weekdays"
        value={formData.weekdays}
        onChange={handleInputChange}
        placeholder="Hari (contoh: monday,tuesday)"
        className="w-full px-4 py-2 border rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
        required
      />
      <div className="flex justify-end gap-2 mt-4">
        <button
          type="button"
          onClick={() =>
            isEdit ? setIsEditModalOpen(false) : setIsAddModalOpen(false)
          }
          className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white"
        >
          Batal
        </button>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          {isEdit ? "Perbarui" : "Tambah"}
        </button>
      </div>
    </form>
  );

  return (
    <div className="p-6 font-sans antialiased text-gray-800 dark:bg-gray-900 dark:text-gray-200 min-h-screen">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        body { font-family: 'Inter', sans-serif; }
      `}</style>

      {/* Toast Notification */}
      {toastMessage && (
        <div
          className={`fixed top-4 right-4 z-50 px-6 py-3 rounded-xl shadow-lg transition-all duration-300 ease-in-out ${
            toastType === "success"
              ? "bg-green-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          {toastMessage}
        </div>
      )}

      {/* Header */}
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-shield-half"
          >
            <path d="M12 21.4c-4 0-8.5-1-10-4.5V11L12 2l10 9v5.9c-1.5 3.5-6 4.5-10 4.5Z" />
            <path d="M12 2v19.4" />
          </svg>
          {deviceName} /
          <UsermanMenu userman_id={usermanId} device_name={deviceName} /> /
          Profile Limitation
        </h1>
        <div className="flex gap-2">
          <button
            className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-xl flex items-center gap-2 shadow-md"
            onClick={fetchLimitations}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-refresh-cw"
            >
              <path d="M21 12A9 9 0 0 0 6 21c-2.7-.7-4.5-2.5-6-4.5" />
              <path d="M3 12A9 9 0 0 1 18 3c2.7.7 4.5 2.5 6 4.5" />
              <path d="M17.5 14.5-1.5 8.5" />
              <path d="M22 12s-4 2-6 2-6-2-12-2-6 2-6 2v2s4-2 6-2 6 2 12 2 6-2 6-2Z" />
            </svg>
            Sinkronisasi
          </button>
          <button
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-xl flex items-center gap-2 shadow-md"
            onClick={() => setIsAddModalOpen(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-plus"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            Tambah Baru
          </button>
        </div>
      </div>

      {/* Filter Section */}
      <div className="mb-4 p-4 rounded-xl shadow bg-white dark:bg-gray-800">
        <h2 className="text-xl font-semibold mb-2">Filter Data</h2>
        <input
          className="w-full border text-black dark:text-white border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
          type="text"
          placeholder="Filter berdasarkan Nama Profil"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
        />
      </div>

      {/* Main Table */}
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="overflow-x-auto rounded-xl shadow bg-white dark:bg-gray-800">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100 dark:bg-gray-700">
              <tr>
                <th className="p-3 text-left font-semibold">Profil</th>
                <th className="p-3 text-left font-semibold">Limitasi</th>
                <th className="p-3 text-left font-semibold">Waktu Mulai</th>
                <th className="p-3 text-left font-semibold">Waktu Selesai</th>
                <th className="p-3 text-left font-semibold">Hari</th>
                <th className="p-3 text-left font-semibold">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {filteredLimitations.map((item) => (
                <tr key={item[".id"]} className="border-t dark:border-gray-700">
                  <td className="p-3">{item.profile}</td>
                  <td className="p-3">{item.limitation}</td>
                  <td className="p-3">{item["from-time"]}</td>
                  <td className="p-3">{item["till-time"]}</td>
                  <td className="p-3">{item.weekdays}</td>
                  <td className="p-3 flex gap-2">
                    <button
                      onClick={() => openEditModal(item)}
                      className="flex items-center gap-1 px-3 py-2 text-blue-600 hover:text-blue-800 rounded-md border border-blue-600 hover:border-blue-800 text-xs"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-pencil"
                      >
                        <path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
                        <path d="m15 5 4 4" />
                      </svg>
                      Edit
                    </button>
                    <button
                      onClick={() => openDeleteModal(item)}
                      className="flex items-center gap-1 px-3 py-2 text-red-600 hover:text-red-800 rounded-md border border-red-600 hover:border-red-800 text-xs"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-trash-2"
                      >
                        <path d="M3 6h18" />
                        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                        <line x1="10" x2="10" y1="11" y2="17" />
                        <line x1="14" x2="14" y1="11" y2="17" />
                      </svg>
                      Hapus
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Add Modal */}
      {isAddModalOpen && (
        <div className="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center">
          <div className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl">
            <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-4">
              Tambah Limitasi Profil Baru
            </h3>
            {renderForm()}
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center">
          <div className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl">
            <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-4">
              Edit Limitasi Profil
            </h3>
            {renderForm(true)}
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 z-10 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center">
          <div className="w-full max-w-sm transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl">
            <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
              Konfirmasi Hapus
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500 dark:text-gray-200">
                Apakah kamu yakin ingin menghapus limitasi profil "
                {itemToDelete?.profile}"? Aksi ini tidak bisa dibatalkan.
              </p>
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <button
                type="button"
                className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white"
                onClick={() => setIsDeleteModalOpen(false)}
              >
                Batal
              </button>
              <button
                type="button"
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                onClick={handleDeleteConfirm}
              >
                Hapus
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsermanProfileLimitation;
